<form [formGroup]="tuleapForm" >
    <app-centre-small-opener>
        <h2 mat-dialog-title dialogTitle class="pd-t-5px text-capitalize">add to tuleap</h2>
        <div contentContainer>
            <div class="row">
                <!-- <mat-form-field class="para-container input-field-formatting col-12">
                    <mat-select disableOptionCentering formControlName="projectName"  panelClass="common-drop-down-class" class="body-font-size" placeholder="Project name" >
                        <mat-option  class="body-font-size" *ngFor = "let items of projectJson; let i = index" (blur)="setProjectName(items.id)" [value]="items.id">
                            {{items.label}}
                        </mat-option>
                    </mat-select>
                    <mat-error *ngIf="signUpCheckError('projectName', 'required')">
                        Please select a project name
                    </mat-error>
                </mat-form-field>     -->
                <mat-form-field class="para-container input-field-formatting col-12">
                <input type="text"
           matInput
           disableOptionCentering formControlName="projectName" 
            panelClass="common-drop-down-class" class="body-font-size" placeholder="Project name" 
           [matAutocomplete]="auto">
    <mat-autocomplete autoActiveFirstOption #auto="matAutocomplete"  (optionSelected)="setProjectName($event.option.value)"
>
      <mat-option *ngFor="let option of filteredOptions | async" [value]="option" >
        {{option}}
      </mat-option>
    </mat-autocomplete>
    <mat-error *ngIf="signUpCheckError('projectName', 'required')">
        Please select a project name
    </mat-error>
</mat-form-field>
            </div>
            <div class="d-flex gap-2 align-items-center">
                <mat-form-field class="para-container input-field-formatting w-100">
                    <mat-select disableOptionCentering [disabled] = "tuleapForm.get('projectName')?.value == '' ? true : false " formControlName="productName" panelClass="common-drop-down-class" class="body-font-size" placeholder="Product" >
                        <mat-option class="body-font-size" *ngFor = "let items of productJson; let i = index" (onSelectionChange)="setProductName(items.label)" [value]="items.id">
                            {{items.label}}
                        </mat-option>
                    </mat-select>
                    <mat-error *ngIf="signUpCheckError('productName', 'required')">
                        Please select a product name
                    </mat-error>
                </mat-form-field>
                <mat-form-field class="para-container input-field-formatting w-100">
                    <mat-select disableOptionCentering [disabled] = "tuleapForm.get('projectName')?.value == '' ? true : false " formControlName="clientName" panelClass="common-drop-down-class" class="body-font-size" placeholder="Client" >
                        <mat-option class="body-font-size" *ngFor = "let items of clientJson; let i = index" (onSelectionChange)="setClientName(items.label)" [value]="items.id">
                            {{items.label}}
                        </mat-option>
                    </mat-select>
                    <mat-error *ngIf="signUpCheckError('clientName', 'required')">
                        Please select a client name
                    </mat-error>
                </mat-form-field>
            </div>
        </div>
        <button type="submit" color = "primary" mat-raised-button actions class="button-container mar-l-8" (click)="onSubmit()">
            SAVE
        </button>
        <button mat-raised-button actions color = "primary" class="button-container mar-l-8" (click) = "closeDialog()">
            CANCEL
        </button>
    </app-centre-small-opener>
    
</form>